export default __webpack_public_path__ + "static/media/Bloodseeker Claymore.865e492c.jpg";